export default "__VITE_ASSET__r$BOcO52__"